import { render, staticRenderFns } from "./PccOrderCargoProperties.vue?vue&type=template&id=7d15a16d&scoped=true&"
import script from "./PccOrderCargoProperties.vue?vue&type=script&lang=js&"
export * from "./PccOrderCargoProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15a16d",
  null
  
)

export default component.exports